import React from 'react';
import colors from './colors'; // Importe o arquivo de cores

const Button = ({
  style,
  color = 'primary',
  variant = 'contained',
  size = 'medium',
  fullWidth = false,
  children,
  onClick,
  disabled = false, // Adicionando a prop disabled
  isLoading = false, // Adicionando a prop isLoading
}) => {
  // Definindo classes baseadas nas props
  const baseClasses = 'font-semibold text-sm focus:outline-none';

  // Adicionando o arredondamento de 8px
  const roundedClasses = 'rounded-[8px]';

  // Cores obtidas do arquivo colors.js
  const colorValues = {
    primary: colors.primary,
    secondary: colors.secondary,
    error: colors.error,
    success: colors.success,
    warning: colors.warning,
    light: colors.light,
  };

  // Variantes (outlined e contained)
  const variantClasses = {
    outlined: 'border-2 border-solid',
    contained: '',
  };

  // Tamanhos do botão (large, medium, small)
  const sizeClasses = {
    small: 'py-1 px-2 text-xs', // Menor tamanho
    medium: 'py-2 px-4 text-sm', // Tamanho padrão (médio)
    large: 'py-3 px-6 text-lg', // Maior tamanho
  };

  // Definindo o estilo de fundo e borda com base nas props
  const backgroundColor = colorValues[color];
  const borderColor = color === 'outlined' ? backgroundColor : null; // Só aplica borda se for "outlined"

  // Estilo de desabilitado
  const disabledStyles = disabled || isLoading
    ? {
        backgroundColor: `${backgroundColor}40`, // Fundo com 40% de opacidade
        color: `${backgroundColor}80`, // Cor do texto mais clara
        borderColor: `${backgroundColor}80`, // Borda mais clara
        cursor: 'not-allowed', // Cursor em forma de bloqueio
        opacity: 0.5, // Reduzindo a opacidade para dar o efeito de desabilitado
      }
    : {};

  // Usando estilos inline para aplicar as cores diretamente
  const buttonStyles = {
    backgroundColor: variant === 'contained' ? backgroundColor : 'transparent',
    color: variant === 'contained' ? 'white' : backgroundColor,
    borderColor: variant === 'outlined' ? backgroundColor : 'transparent',
    borderWidth: variant === 'outlined' ? '2px' : '0',
    borderStyle: variant === 'outlined' ? 'solid' : 'none',
    hoverBackgroundColor: variant === 'contained' ? `${backgroundColor}80` : 'transparent', // Adiciona hover com 80% de opacidade
    ...disabledStyles, // Adiciona os estilos de desabilitado
  };

  // Adicionando a classe w-full quando fullWidth é verdadeiro
  const fullWidthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      onClick={disabled || isLoading ? null : onClick} // Não dispara o onClick se o botão estiver desabilitado ou em loading
      className={`${baseClasses} ${roundedClasses} ${sizeClasses[size]} ${fullWidthClass}`}
      style={{
        backgroundColor: buttonStyles.backgroundColor,
        color: buttonStyles.color,
        borderColor: buttonStyles.borderColor,
        borderWidth: buttonStyles.borderWidth,
        borderStyle: buttonStyles.borderStyle,
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer', // Ajustando o cursor
        opacity: disabled || isLoading ? 0.5 : 1, // Opacidade reduzida para indicar desabilitado
        ...style,
      }}
      disabled={disabled || isLoading} // Aplica a prop disabled ao botão
    >
      {isLoading ? (
        <span className="loader">...</span> // Aqui você pode substituir por um ícone de carregamento
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
